// src/features/api/apiSlice.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: "https://primebank.com.np/pr1me4dm1n/api",
    // You can add headers if needed, e.g.:
    // prepareHeaders: (headers) => {
    //   headers.set('Authorization', `Bearer ${token}`);
    //   return headers; 
    // },
  }),
  tagTypes: ["Home"],

  endpoints: (builder) => ({
    getHome: builder.query({
      query: () => "/home",

      // ✅ Provide default fallback (optimistic UI)
      transformResponse: (response) => ({
        banners: response?.banners ?? [],
        news: response?.news ?? [],
        audio: response?.audio ?? [],
        grievance_officer: response?.grievance_officer ?? null,
        information_officer: response?.information_officer ?? null,
        compliance_officer: response?.compliance_officer ?? null,
        company_secretary: response?.company_secretary ?? null,
        popups: response?.popups ?? [],
        service_category: response?.service_category ?? [],
        interest_rates: response?.interest_rates ?? [],
        videos: response?.videos ?? [],
        offers_category: response?.offers_category ?? [],
      }),

      // ✅ Enable aggressive caching and reuse
      keepUnusedDataFor: 60 * 5, // cache data for 5 minutes
      refetchOnMountOrArgChange: false,
      refetchOnReconnect: true, // refresh only if user reconnects

      // ✅ Optional: Preload from cache instantly
      async onQueryStarted(_, { queryFulfilled, getState, dispatch }) {
        const start = performance.now();
        try {
          await queryFulfilled;
          const end = performance.now();
          if (process.env.NODE_ENV === "development") {
            console.log(
              `✅ /home API responded in ${(end - start).toFixed(1)} ms`
            );
          }
        } catch (err) {
          if (process.env.NODE_ENV === "development") {
            console.error("❌ /home API failed:", err);
          }
        }
      },

      providesTags: ["Home"],
    }),
  }),
});

export const { useGetHomeQuery } = apiSlice;
